export default "__VITE_ASSET__BEA$vK_U__"